import urlregexp from 'urlregexp';

export const isTextLink = (text) => text && text.split('\n').length === 1 && text.match(urlregexp);
